// extracted by mini-css-extract-plugin
export default {"root":"OP1eD8"};